<ax-avatar-by-profile
  [profile]="profile"
  [edit]="edit"
  [badge]="badge$ | async"
  [badgeColor]="badgeColor$ | async"
  [border]="border"
  (update)="update.emit($event)"
></ax-avatar-by-profile>
